export default __webpack_public_path__ + "static/project-slide-8-992-765-8f1f19abc435ea95c1269dd3d0ab1f61.webp";